// kendo
import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import { orderBy } from "@progress/kendo-data-query";
// api
import { GetPublicApplicationsTrackingTrackingTypeDto } from "../../../../api/Client";
// common
import * as GlobalHelpers from "../../../../common/GlobalHelpers";
// me
import { IFilterViewModel } from "../models/models";

// constants
const inProgressRadioValue = "inProgress";
const completedRadioValue = "completed";
const defaultApplicationTrackingType = new GetPublicApplicationsTrackingTrackingTypeDto({ name: "All OPGGS Applications" });

interface IProps {
    filterState: IFilterViewModel;
    applicationTrackingTypes: GetPublicApplicationsTrackingTrackingTypeDto[];
    onFilterStateChanged: (values: IFilterViewModel) => void;
    onShowFilter: () => void;
    onResetFilter: () => void;
}

export default function FilterView(props: IProps) {
    const { filterState, applicationTrackingTypes, onFilterStateChanged, onShowFilter, onResetFilter } = props;

    const selectedRadioValue = GlobalHelpers.convertBooleanToRadioValue(filterState.isCompleted, completedRadioValue, inProgressRadioValue);
    const sortedApplicationTrackingTypes = orderBy(applicationTrackingTypes, [{ field: "name", dir: "asc" }]);

    function handleRadioValueChanged(e: React.ChangeEvent<HTMLInputElement>) {
        if (e.target.value === inProgressRadioValue) onFilterStateChanged({ ...filterState, isCompleted: false });
        if (e.target.value === completedRadioValue) onFilterStateChanged({ ...filterState, isCompleted: true });
    }

    function handleApplicationTrackingTypeChanged(e: DropDownListChangeEvent) {
        onFilterStateChanged({ ...filterState, applicationTrackingType: e.target.value?.id });
    }

    return (
        <div className="row row-cols-sm-auto g-3 mb-4 align-items-center">
            <div className="col-12">
                <label htmlFor="applicationTrackingType" className="col-form-label">
                    Application Type
                </label>
            </div>
            <div className="col-12">
                <DropDownList
                    title="Select Application Type (default selection: All)."
                    style={{ width: "25rem" }}
                    id="applicationTrackingType"
                    data={sortedApplicationTrackingTypes}
                    value={sortedApplicationTrackingTypes.find((at) => at.id === filterState.applicationTrackingType) ?? defaultApplicationTrackingType}
                    dataItemKey="id"
                    defaultItem={defaultApplicationTrackingType}
                    onChange={handleApplicationTrackingTypeChanged}
                    textField="name"
                    popupSettings={{ height: "350" }}
                />
            </div>
            <div className="col-12">
                <div className="form-check form-check-inline">
                    <input
                        className="form-check-input"
                        type="radio"
                        id="inProgressRadio"
                        name="isCompletedGroup"
                        value={inProgressRadioValue}
                        checked={selectedRadioValue === inProgressRadioValue}
                        onChange={handleRadioValueChanged}
                    />
                    <label className="form-check-label" htmlFor="inProgressRadio">
                        In Progress
                    </label>
                </div>
                <div className="form-check form-check-inline">
                    <input
                        className="form-check-input"
                        type="radio"
                        id="completedRadio"
                        name="isCompletedGroup"
                        value={completedRadioValue}
                        checked={selectedRadioValue === completedRadioValue}
                        onChange={handleRadioValueChanged}
                    />
                    <label className="form-check-label" htmlFor="completedRadio">
                        Completed
                    </label>
                </div>
            </div>
            <div className="col-12">
                <button id="showButton" className="btn btn-outline-primary me-1" type="button" onClick={onShowFilter}>
                    Show
                </button>
                <button id="resetButton" className="btn btn-outline-secondary" type="button" onClick={onResetFilter}>
                    Reset
                </button>
            </div>
        </div>
    );
}
